/* eslint-disable no-nested-ternary */
import { BRAND_REMOVED_FROM_ANVISA_MESSAGE, DISTRIBUTORS_HUB, LIST_BRAND_ATTENDANT } from '@cannect/constants/products'
import { RedirectUrls } from '@cannect/constants/texts'
import { PrescriptionBadges } from '@cannect/new-components/atoms'
import CuratorshipGauge from '@cannect/new-components/atoms/CuratorshipGauge'
import { ProductModalDisabled } from '@cannect/new-components/ProductModalDisabled'
import { ProductModalDisabledNutraceutico } from '@cannect/new-components/ProductModalDisabledNutraceutico'
import { cannectDefaultProduct, cannectDefaultProductNoTarg } from 'assets/img'
import useMediaQuery from 'hooks/useMediaQuery'
import { usePrepareCart } from 'hooks/usePrepareCart'
import useSignedUser from 'hooks/useSignedUser'
import { useTokenApi } from 'hooks/useTokenApi'
import { SelectFlavorModal } from 'new-components/SelectFlavorModal'
import { MinusCircle, Receipt } from 'phosphor-react'
import { useEffect, useState } from 'react'
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai'
import { BiLoaderCircle } from 'react-icons/bi'
import { FiLock, FiShoppingCart } from 'react-icons/fi'
import { useLocation } from 'react-router'
import { toast } from 'react-toastify'
import api from 'services/api'
import { temporaryTheme } from 'styles/theme'
import { MOBILE_WIDTH } from 'utils/constants'
import When from '../../../utils/when'
import PromotionalPrice from '../PromotionalPrice'
import * as Styles from './styles'

export interface ProductCardProps {
  name?: string
  translated_name?: string
  isFavorite?: boolean
  real_price?: number
  image?: string
  handleFavorite?: () => void
  id: number
  supplier_id?: number
  importProduct?: (val: any) => void
  handleLogin?: any
  promotional?: any
  product?: any
  isAssistant?: boolean
  prescribedProduct?: boolean
  stock?: number
  isRelatedProduct?: boolean
  isSupllements?: boolean
  setOpenModalSupplements?: any
}

export default function ProductCard({
  name,
  translated_name,
  isFavorite,
  handleFavorite = () => null,
  real_price,
  image,
  id,
  supplier_id,
  importProduct = () => null,
  handleLogin = () => null,
  promotional,
  product,
  isAssistant,
  prescribedProduct,
  isRelatedProduct,
  stock,
  isSupllements = false,
  setOpenModalSupplements
}: ProductCardProps) {
  const isMobile = useMediaQuery(MOBILE_WIDTH)
  const { signedUser } = useSignedUser()
  const { tokenApi } = useTokenApi()
  const { addToCart, loadingCupon, lastOrderCreated, AddToCartByFlavor } = usePrepareCart()
  const location = useLocation()
  const [products, setProducts] = useState<any[]>([])
  const [flavorModal, setFlavorModal] = useState(false)
  const [loadingOnSave, setLoadingOnSave] = useState(false)
  const [defaultSelectedFlavor, setDefaultSelectedFlavor] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const [hasMultipleFlavors, setHasMultipleFlavors] = useState(false)
  const [shippingText, setShippingText] = useState('')
  const [stockValue, setstockValue] = useState<any>(0)
  const [nutraceuticosModal, setNutraceuticosModal] = useState(false)
  const [anvisaModal, setAnvisaModal] = useState<boolean>(false)
  const [anvisaModalMessage, setAnvisaModalMessage] = useState<string>('')
  const [modalUrlClickButton, setModalUrlClickButton] = useState<string>('')
  const [learnMore, setLearnMore] = useState<boolean>(false)
  const class_id = product?.class_id
  const brand_id = product?.brand_id
  const type = product?.type
  // Using centralized constants

  const requiresLoginAtAdd = (p: any) => p?.is_cannabis === true

  useEffect(() => {
    if (lastOrderCreated?.items) {
      const essentialProductsData = products.map((product: any) => ({
        id: product.product.id,
        quantity: product.quantity
      }))
      setProducts(essentialProductsData)
    }
  }, [lastOrderCreated])

  useEffect(() => {
    setLoading(loadingCupon)
  }, [loadingCupon])

  useEffect(() => {
    if (stock !== undefined) {
      setstockValue(stock)
    }
  })

  useEffect(() => {
    const checkMultipleFlavors = async () => {
      let shippingText = ''

      if (product?.class?.id === 6) {
        setShippingText(shippingText)
        return
      }

      const { data } = await api.get(`/get_product_flavors/${id}`)
      const hasFlavors = data?.success && Array.isArray(data.productFlavors) && data.productFlavors.length > 0

      const isImported =
        product.supplier_id !== 18 && product.class?.id !== 6 && DISTRIBUTORS_HUB.includes(product.distributor_id)

      const isOutOfStock = product.stock <= 0

      if (hasFlavors) {
        setHasMultipleFlavors(true)
      } else {
        setHasMultipleFlavors(false)
      }

      if (isImported && !isOutOfStock) {
        shippingText = 'Importado: entrega em até 15 dias úteis.'
      }

      if (!DISTRIBUTORS_HUB.includes(product.distributor_id)) {
        shippingText = 'Entrega em até 25 dias úteis.'
      }

      if (isOutOfStock && isImported && !isSupllements) {
        shippingText = 'Possível maior tempo de entrega'
      }

      if (product.supplier_id === 18) {
        shippingText = 'Entrega de origem nacional. Receba em até 5 dias úteis.'
      }

      if (product.supplier_id === 148) {
        shippingText = 'Entrega em até 7 dias úteis.'
      }

      setShippingText(shippingText)
    }

    checkMultipleFlavors()
  }, [id, product])

  const handleSaveFlavor = async (items: any[]) => {
    setLoadingOnSave(true)
    const itemArray = Array.isArray(items) ? items : [items]

    if (isAssistant) {
      await importProduct(itemArray)
    } else {
      await AddToCartByFlavor(itemArray)
    }
  }

  const handleOk = () => {
    setLoadingOnSave(false)
    setFlavorModal(false)
  }

  const getProductDetails = () => {
    if (isSupllements) {
      window.open(`/detalhes-produtos_suplementos/${id}`, '_blank')
    } else {
      const normalizeText = (text: string) => text.trim().replace(/\s+/g, '-').replace(/-+/g, '-')

      const brandName = normalizeText(product?.brand?.name || '')
      const productName = normalizeText(product?.name.replace('/', '-') || '')

      window.open(`/detalhes-produtos/${id}`, '_blank')
    }
  }

  const handleFavoriteCard = () => {
    handleFavorite()
    try {
      api.post(`/product/favorite/${id}`)
    } catch (e) {
      toast.error('Erro ao favoritar')
      handleFavorite()
    }

    const msg = isFavorite ? 'Produto removido dos favoritos' : 'Produto adicionado aos favoritos'
    toast.success(msg)
  }

  const textAssistant = prescribedProduct ? 'Selecionado' : 'Prescrever'

  const infoBySupplier = {
    shippingText,
    buttonText: supplier_id === 18 || class_id === 6 ? 'Comprar' : 'Adicionar ao carrinho',
    defaultImage: supplier_id === 18 || class_id === 6 ? cannectDefaultProduct : cannectDefaultProductNoTarg
  }

  const handleAddToCart = async (id: number) => {
    if (isSupllements) {
      setOpenModalSupplements(true)
      return
    }

    const brandIdForRules = product?.brand?.id ?? product?.brand_id
    if (LIST_BRAND_ATTENDANT.includes(brandIdForRules)) {
      setFlavorModal(false)
      setAnvisaModal(true)
      setModalUrlClickButton(RedirectUrls.WHATSAPP_SALES)
      setLearnMore(true)
      setAnvisaModalMessage(BRAND_REMOVED_FROM_ANVISA_MESSAGE)
      return
    }

    if (hasMultipleFlavors && !isAssistant) {
      setAnvisaModal(false)
      setFlavorModal(true)
      setDefaultSelectedFlavor(product)
      setLoading(false)
      return
    }

    setLoading(true)
    try {
      if (isAssistant) {
        await importProduct(product)
      } else {
        await addToCart(id, 1, product.class_id, product.brand_id, product.type, product?.is_cannabis)
      }
    } catch (e) {
      console.error('Erro ao adicionar ao carrinho: ', e)
    } finally {
      setLoading(false)
    }
  }

  const handleCloseFlavorModal = () => {
    setFlavorModal(false)
  }

  const handleCloseAnvisa = () => {
    setAnvisaModal(false)
  }

  const isPillProduct = product?.origin === 'pill'
  const sellable = product?.sellable !== undefined ? product.sellable : true

  const [loadingNotifyMe, setLoadingNotifyMe] = useState(false)

  const handleNotifyMe = async () => {
    if (!tokenApi) {
      sessionStorage.setItem('@CANNECT:PENDING_NOTIFY_ME', JSON.stringify({ productId: id, source: 'portal_card' }))
      handleLogin()
      return
    }
    setLoadingNotifyMe(true)
    try {
      const res = await api.post(`/product/${id}/notify-me`, { source: 'portal_card' })
      const alreadyExisted = res?.data?.created === false
      toast.success(
        alreadyExisted
          ? 'Você já estava na lista de espera para este produto!'
          : 'Você será avisado quando o produto estiver disponível!'
      )
    } catch {
      toast.error('Erro ao registrar interesse. Tente novamente.')
    } finally {
      setLoadingNotifyMe(false)
    }
  }

  const getSelectedImage = () => {
    if (isPillProduct) {
      return image || infoBySupplier.defaultImage
    }
    if (!signedUser) {
      return infoBySupplier.defaultImage
    }
    if (signedUser.registration_type === 1) {
      return product?.class_id === 6 ? image : infoBySupplier.defaultImage
    }
    return image
  }

  const selectedImage = getSelectedImage()

  return (
    <Styles.Wrapper withAuth={!!tokenApi}>
      <Styles.DetailsContent>
        <When expr={!!tokenApi}>
          <Styles.FavoriteBox onClick={handleFavoriteCard}>
            {isFavorite ? <AiFillHeart color={temporaryTheme.colors.red} /> : <AiOutlineHeart color="#858585" />}
          </Styles.FavoriteBox>
        </When>

        <Styles.ImageContainer>
          <Styles.ImageBox>
            <Styles.Image src={selectedImage} alt={`imagem do produto ${name}`} />

            <Styles.MoreInfo>
              <Styles.ButtonMoreInfo onClick={getProductDetails}>detalhes</Styles.ButtonMoreInfo>
            </Styles.MoreInfo>
          </Styles.ImageBox>
        </Styles.ImageContainer>

        <Styles.TitleProductBox onClick={getProductDetails}>
          <Styles.TitleProduct>{translated_name || name}</Styles.TitleProduct>

          <CuratorshipGauge percentage={product?.curatorship?.percentage} />

          <PrescriptionBadges codes={product?.prescription_badges} className="mt-1" />

          <When
            expr={
              sellable !== false &&
              (!!tokenApi || isSupllements || isPillProduct) &&
              isMobile &&
              !isRelatedProduct &&
              !isAssistant
            }>
            <Styles.PriceBox>
              {/* <Styles.Price>
                {formatPrice({
                  value: validPromotion ? promotional?.promotional_price : real_price,
                  currencyDisplay: 'symbol',
                  currencyStyle: 'BRL',
                  type: 'pr-br'
                })}
              </Styles.Price> */}
              <PromotionalPrice
                new_price={promotional?.promotional_price || product?.real_price}
                old_price={promotional?.regular_price}
                discount={promotional?.discount_value}
                discount_type={promotional?.discount_type}
              />
            </Styles.PriceBox>
          </When>
        </Styles.TitleProductBox>
      </Styles.DetailsContent>

      <Styles.ProductSabor
        bgColor={supplier_id === 18 || class_id === 6 ? 'green' : 'orange'}
        fontColor={supplier_id === 18 || class_id === 6 ? 'green' : 'orange'}>
        {!!loading && (
          <div className="load-box">
            <BiLoaderCircle />
          </div>
        )}
        {supplier_id === 18 ? 'Entrega imediata!' : product?.class?.id === 6 ? 'Frete grátis' : 'Necessário prescrição'}
      </Styles.ProductSabor>

      <Styles.ActionsContent isAssistant={isAssistant}>
        <When
          expr={
            sellable !== false &&
            (!!tokenApi || isSupllements || isPillProduct) &&
            (!isMobile || isAssistant) &&
            !isRelatedProduct
          }>
          <Styles.PriceBox>
            {/* <Styles.Price>
              {formatPrice({
                value: validPromotion ? promotional?.promotional_price : real_price,
                currencyDisplay: 'symbol',
                currencyStyle: 'BRL',
                type: 'pr-br'
              })}
            </Styles.Price> */}
            <PromotionalPrice
              new_price={promotional?.promotional_price || product?.real_price}
              old_price={promotional?.regular_price}
              discount={promotional?.discount_value}
              discount_type={promotional?.discount_type}
            />
          </Styles.PriceBox>
        </When>

        <Styles.ActionBox>
          {sellable === false && !isAssistant ? (
            <Styles.ButtonProduct
              onClick={handleNotifyMe}
              isLoading={loadingNotifyMe}
              className="button-action_product"
              bgColor="orange">
              {!!loadingNotifyMe && (
                <div className="load-box">
                  <BiLoaderCircle />
                </div>
              )}
              Avise-me
            </Styles.ButtonProduct>
          ) : tokenApi || isSupllements || !requiresLoginAtAdd(product) ? (
            <div className="acc">
              {isAssistant ? (
                <Styles.ButtonAssistant
                  onClick={() => handleAddToCart(id)}
                  isLoading={loading}
                  prescribedProduct={!!prescribedProduct}>
                  {!!loading && (
                    <div className="load-box">
                      <BiLoaderCircle />
                    </div>
                  )}
                  {textAssistant}

                  {prescribedProduct ? <MinusCircle size={18} /> : <Receipt size={18} />}
                </Styles.ButtonAssistant>
              ) : (
                <Styles.ButtonProduct
                  onClick={() => handleAddToCart(id)}
                  isLoading={loading}
                  className="button-action_product"
                  bgColor={supplier_id === 18 || class_id === 6 ? 'green' : 'orange'}>
                  {!!loading && (
                    <div className="load-box">
                      <BiLoaderCircle />
                    </div>
                  )}
                  {infoBySupplier.buttonText} {isSupllements ? <FiLock /> : <FiShoppingCart />}
                </Styles.ButtonProduct>
              )}
            </div>
          ) : (
            <Styles.ButtonProduct onClick={handleLogin}>Faça login para ver mais</Styles.ButtonProduct>
          )}
        </Styles.ActionBox>

        <When expr={(!!tokenApi || isSupllements) && !isAssistant}>
          <Styles.DetailsTrack isEmpty={!shippingText}>{shippingText || ' '}</Styles.DetailsTrack>
        </When>
      </Styles.ActionsContent>

      {/* <SelectFlavorModal
          open={flavorModal}
          handleCancel={handleCloseFlavorModal}
          handleOk={() => handleOk()}
          isAssistant={isAssistant as boolean}
          defaultSelected={defaultSelectedFlavor}
          onSave={(items) => handleSaveFlavor(items)}
          loadingOnSave={loadingOnSave}
          isAuthenticated={!!tokenApi}
          imageSelector={(isAuthenticated, defaultSelected) =>
            isPillProduct
              ? defaultSelected.image || infoBySupplier.defaultImage
              : isAuthenticated
                ? (signedUser?.registration_type === 1 && product?.class_id !== 6
                    ? infoBySupplier.defaultImage
                    : defaultSelected.image) || 'path/to/authenticated/default/image.jpg'
                : 'path/to/public/default/image.jpg'
          }
        /> */}

      <ProductModalDisabledNutraceutico
        open={nutraceuticosModal}
        handleCancel={() => setNutraceuticosModal(false)}
        isAuthenticated={!!tokenApi}
      />
      {anvisaModal ? (
        <ProductModalDisabled
          open={anvisaModal}
          learnMore={learnMore}
          message={anvisaModalMessage}
          urlRedirect={modalUrlClickButton}
          handleCancel={handleCloseAnvisa}
          isAuthenticated={!!tokenApi}
          onClick={async () => {
            if (hasMultipleFlavors && !isAssistant) {
              setAnvisaModal(false)
              setFlavorModal(true)
              setDefaultSelectedFlavor(product)
              setLoading(false)
            } else {
              try {
                if (isAssistant) {
                  await importProduct(product)
                } else {
                  await addToCart(id)
                }
              } catch (e) {
                console.log('Erro na busca de sabores: ', e)
              } finally {
                setLoading(false)
              }
            }
          }}
        />
      ) : (
        hasMultipleFlavors &&
        !isAssistant && (
          <SelectFlavorModal
            open={flavorModal}
            handleCancel={handleCloseFlavorModal}
            handleOk={() => handleOk()}
            isAssistant={isAssistant as boolean}
            defaultSelected={defaultSelectedFlavor}
            onSave={(items) => handleSaveFlavor(items)}
            loadingOnSave={loadingOnSave}
            isAuthenticated={!!tokenApi}
            imageSelector={(isAuthenticated, defaultSelected) =>
              isPillProduct
                ? defaultSelected.image || infoBySupplier.defaultImage
                : isAuthenticated
                  ? (signedUser?.registration_type === 1 && product?.class_id !== 6
                      ? infoBySupplier.defaultImage
                      : defaultSelected.image) || 'path/to/authenticated/default/image.jpg'
                  : 'path/to/public/default/image.jpg'
            }
          />
        )
      )}
    </Styles.Wrapper>
  )
}
